import * as React from "react";
import type { SVGProps } from "react";
const SvgSkipBack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m19 20-.625.78A1 1 0 0 0 20 20zM9 12l-.625-.78a1 1 0 0 0 0 1.56zm10-8h1a1 1 0 0 0-1.625-.78zM4 19a1 1 0 1 0 2 0zM6 5a1 1 0 0 0-2 0zm13.625 14.22-10-8-1.25 1.56 10 8zm-10-6.44 10-8-1.25-1.56-10 8zM18 4v16h2V4zM6 19V5H4v14z"
    />
  </svg>
);
export default SvgSkipBack;
